export default __webpack_public_path__ + "_/images/bonuses/bonuses-card/lightning-d7c9788f6f0177ec87f23524a772b106b4fc23a020e33946dee038a37cead7b6.png";